import { FC, ReactNode } from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    children?: ReactNode;
    tabs?: ReactNode;
}

/**
 * Common Page Header Component
 * Provides consistent typography and layout for page-level headings
 */
export const PageHeader: FC<PageHeaderProps> = ({ title, subtitle, children, tabs }) => {
    return (
        <div className="w-full bg-white border-b border-slate-200">
            <div className="px-6 pt-6 md:px-8">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                    <div>
                        <h1 className="text-2xl font-bold text-slate-900 tracking-tight">{title}</h1>
                        {subtitle && (
                            <p className="text-sm text-slate-500 mt-1 font-medium">{subtitle}</p>
                        )}
                    </div>
                    {children && (
                        <div className="flex items-center gap-3">
                            {children}
                        </div>
                    )}
                </div>
                {tabs && (
                    <div className="-mb-px">
                        {tabs}
                    </div>
                )}
            </div>
        </div>
    );
};
